import { showErrorMessage } from '../../messages';
import { quotesApi } from '../../../services/api/quotes-api';
import {
  QUOTES_LOAD_SUCCESS,
  QUOTES_COUNT_SUCCESS,
  QUOTES_MODAL_CLOSE,
  QUOTES_PAGE_CHANGE,
  QUOTES_SELECTION_SUCCESS,
} from './action-types';
import { tasksApi } from '../../../services/api/tasks-api';

export function closeModal() {
  return {
    type: QUOTES_MODAL_CLOSE,
  };
}

export function changePage(newPage) {
  return {
    type: QUOTES_PAGE_CHANGE,
    payload: newPage,
  };
}

export function loadQuotesRequest(page, waiting, denied, agg, perPage) {
  return (dispatch) => {
    return quotesApi
      .getQuotes(page, waiting, denied, agg, perPage)
      .then((response) => {
        if (response.ok) {
          dispatch(loadQuotesSuccess(response.quotes));
          dispatch(changePage(page));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
  };
}

export function loadQuotesSuccess(quotes) {
  return {
    type: QUOTES_LOAD_SUCCESS,
    payload: quotes,
  };
}

export function quotesCount(filters) {
  return (dispatch) => {
    return quotesApi.getQuotesCount(filters).then((response) => {
      if (response.ok) {
        dispatch(quotesCountSuccess(response.count));
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function quotesCountSuccess(count) {
  return {
    type: QUOTES_COUNT_SUCCESS,
    payload: count,
  };
}

export function selectQuoteRequest(quoteIndex, taskId) {
  return (dispatch) => {
    return tasksApi.getTask(taskId).then((response) => {
      if (response.ok) {
        dispatch(
          selectQuoteSucess(
            quoteIndex,
            response.task.images.map((image) => {
              return {
                id: image.id,
                url: image.image.url,
                preview: image.image.preview.url,
              };
            })
          )
        );
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function selectQuoteSucess(quoteIndex, images) {
  return {
    type: QUOTES_SELECTION_SUCCESS,
    payload: { quoteIndex, images },
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/quotes/quotes.js